import { DEFAULT_STUDIO_CATEGORY_SLUG } from './config';

interface TemplatesBuildParams {
  slug: string;
  searchParams?: URLSearchParams;
}

interface SearchBuildParams {
  criteria: string;
  searchParams?: URLSearchParams;
}

export const appRoutes = {
  templates: {
    pattern: '/:categorySlug?',
    build: ({ searchParams: urlSearchParams, slug }: TemplatesBuildParams) => {
      const searchParams = new URLSearchParams(urlSearchParams);
      searchParams.delete('criteria');
      const search = searchParams.toString()
        ? `?${searchParams.toString()}`
        : '';

      return slug === DEFAULT_STUDIO_CATEGORY_SLUG
        ? `/${search}`
        : `/${slug}${search}`;
    },
  },
  search: {
    build: ({ searchParams: urlSearchParams, criteria }: SearchBuildParams) => {
      const searchParams = new URLSearchParams(urlSearchParams);
      searchParams.set('criteria', criteria);
      return `/?${searchParams?.toString()}`;
    },
  },
};
